import type { BlockDef } from '../../prop-types.ts'
import { EMPTY_TEXT } from '../../text.ts'

/** Body copy. `longText` rather than `text`, which is what tells the editor to give it a textarea
 *  and the renderer to split it on blank lines into paragraphs. */
export const text: BlockDef = {
  type: 'text',
  v: 1,
  label: { en: 'Text', ar: 'نص' },
  scope: 'page',
  description: 'A block of prose — a paragraph or several. Can sit at half or a third width beside an image.',
  whenToUse: 'The story, the description, the terms — anywhere the answer is sentences.',
  whenNotToUse: 'For a list of short benefits with icons — that is a Features block, which reads far better on a phone.',
  variants: [
    { value: 'plain', label: { en: 'Plain', ar: 'عادي' } },
    { value: 'lead', label: { en: 'Larger opening', ar: 'افتتاحية أكبر' } },
    { value: 'boxed', label: { en: 'In a box', ar: 'داخل إطار' } },
  ],
  fields: [
    { key: 'heading', label: { en: 'Heading', ar: 'العنوان' }, type: { kind: 'text' }, default: EMPTY_TEXT },
    {
      key: 'body',
      label: { en: 'Text', ar: 'النص' },
      // ⚠️ PLAIN TEXT, NOT MARKDOWN, AND NOT HTML. Blank lines become paragraphs and nothing else is
      // interpreted. The moment this renders markup, the render path — which emits static HTML
      // outside React (CLAUDE.md §2.7) — becomes an injection surface for anything a customer or a
      // model wrote. Rich formatting, if it is ever wanted, is a structured field, not a syntax.
      type: { kind: 'longText' },
      default: EMPTY_TEXT,
      requiredForPublish: true,
      hint: { en: 'Leave a blank line between paragraphs.', ar: 'اترك سطرًا فارغًا بين الفقرات.' },
    },
  ],
}
